import { BreakpointsTable, SideNavigationAsideTable } from '@af/design-system-docs-ui';
import Link from '@atlaskit/link';
import SectionMessage from '@atlaskit/section-message';
import * as React from 'react';
export default {
  BreakpointsTable,
  SideNavigationAsideTable,
  Link,
  SectionMessage,
  React
};